"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrixelIcon = props => {
  const {
    background = '',
    className = '',
    color = '',
    icon,
    iconSize = 'normal',
    iconWidth = '',
    isLoading = false,
    label = '',
    onClick = null,
    padding = null,
    rounded = false,
    saturation = color === 'text' ? 700 : 400,
    saturationTxt = color === 'text' ? 700 : 400,
    tooltipWidth = ''
  } = props;
  const bgClass = background ? `${background.charAt(0).toUpperCase()}${background.slice(1)}` : '';
  const colorClass = color ? `${color.charAt(0).toUpperCase()}${color.slice(1)}` : '';
  const classBackground = background ? `bg${bgClass}${saturation > 0 ? saturation : ''}` : '';
  const classColor = color ? `icn${colorClass}${saturationTxt > 0 ? saturationTxt : ''}` : '';
  const classRounded = rounded ? 'brdCircle' : 'brdRadius';
  const pad = background ? 'p-1' : '';
  const cursor = onClick ? 'cur-poi' : '';
  function importAll(r) {
    const images = {};
    r.keys().forEach(item => {
      images[item.replace('./', '')] = r(item);
    });
    return images;
  }
  const loadIcon = () => {
    // @ts-ignore
    if (process.env.NODE_ENV !== 'test') {
      const images = importAll(require.context('../images/Icons/svg', false, /\.(png|jpe?g|svg)$/));
      const objIcons = {};
      Object.keys(images).forEach(key => {
        objIcons[key.replace('.svg', '')] = images[key];
      });
      const ordered = Object.keys(objIcons).sort().reduce((obj, key) => {
        obj[key] = objIcons[key];
        return obj;
      }, {});
      return ordered[icon];
    }
  };
  const loadingAnimClass = `${colorClass}${saturationTxt > 0 ? saturationTxt : ''}`;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: `brixelIcon ${label ? 'withTooltip' : ''} ${iconSize} ${className} ${classBackground} ${classRounded} ${padding || pad} ${cursor} pos-r`
  }, isLoading ? (/*#__PURE__*/_react.default.createElement("div", {
    className: "btnLoader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "lds-ring"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${loadingAnimClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${loadingAnimClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${loadingAnimClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${loadingAnimClass}`
  })))) : (/*#__PURE__*/_react.default.createElement("i", {
    className: `icon-${icon} ${classColor} ${iconWidth}`,
    onClick: e => onClick ? onClick(e) : ''
  }, (0, _lodash.get)(loadIcon(), 'ReactComponent', null) ? /*#__PURE__*/_react.default.createElement((0, _lodash.get)(loadIcon(), 'ReactComponent', ''), {
    viewBox: '0 0 24 24'
  }) : null)), label && (/*#__PURE__*/_react.default.createElement("span", {
    className: "tooltipLabel fsize-200",
    style: {
      minWidth: `${tooltipWidth}px`
    }
  }, label)));
};
var _default = exports.default = BrixelIcon;